import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ListStoryGroupModel } from 'src/app/models/story/list-story-group.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../../base-page';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-list-stories',
    templateUrl: './list-stories.component.html',
    styleUrls: ['./list-stories.component.scss'],
    standalone: false
})
export class ListStoriesComponent extends BasePage implements OnInit {

    private mApiService = inject(ApiService);
    private mMessageService = inject(MessageService);

    public items: ListStoryGroupModel[] = [];

    public isDeleting: { [id: string]: boolean } = {};

    ngOnInit(): void {
        this.getData();
    }

    public deleteItem(item: ListStoryGroupModel) {
        if (!confirm('Удалить эту группу историй?')) {
            return;
        }

        this.isDeleting[item.id] = true;
        this.mApiService.delete(`/api/admin/story/group/${item.id}`).subscribe({
            next: () => {
                this.items.splice(this.items.indexOf(item), 1);
                
                this.mMessageService.addMessage({
                    text: 'Сторис удалена',
                    type: this.mMessageService.types.success
                });
            },
            error: () => this.isDeleting[item.id] = false
        });
    }

    public getData(): void {
        this.isBusy = true;

        this.mApiService.get<ListStoryGroupModel[]>('/api/admin/story/groups').subscribe({
            next: (r) => {
                this.items = r;
                this.isBusy = false;
            },
            error: () => this.isBusy = false
        });
    }

}
